import React, { useState, useEffect } from 'react'
import { Breadcrumb, Row, Col, Button, Input, Layout, theme, Modal, Space, Table, Drawer, Pagination } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import AsyncStorage from '@react-native-async-storage/async-storage';

import {
  CloseOutlined,
  LoadingOutlined,
  CheckOutlined,
} from '@ant-design/icons';
import * as yup from 'yup';

//Dispatchs
import { Creators as ProductModelsActions } from '../../../store/reducers/product_models'
import { Creators as RefreshActions } from '../../../store/reducers/refresh';

//Styles And Helpers

//Contexts

//Components
import FooterDefault from '../../../components/LayoutDefault/FooterDefault'
import Show from './actions/Show'
import Sugestions from './actions/Sugestions';

//Variables
const filterListSchema = yup.object().shape({

});

const { Content } = Layout;

const Models = () => {

  //Dispatchs
  const dispatch = useDispatch();

  //States Reducer
  const { dataProductModelsList, loadingProductModelsList, dataProductModelsListUpdate } = useSelector((state) => (state.products_models))

  //States Local
  const {
    token: { colorBgContainer, colorWarning, colorError, colorInfo },
  } = theme.useToken();

  //---- Open Filter Table
  const [openModalFilter, setOpenModalFilter] = useState(false);

  const title = 'Modelos'
  const [openTypeContentDrawer, setOpenTypeContentDrawer] = useState({
    details: {
      status: false,
      title: `Detalhes ${title}`,
      dataShow: {}
    },
    sugestions: {
      status: false,
      title: `Sugestões de ${title}`,
      dataSugestions: {}
    }
  });
  const [filters, setFilters] = useState({
    name: '',
    code: '',
    machineType: '',
    machineTypeCode: ''
  }
  );

  //Context

  //Cicle of Life
  useEffect(() => {
    document.title = 'Modelos - Iguaçu Máquinas';
    const autoLogin = async () => {
      const refreshToken = await AsyncStorage.getItem('iguacu:refresh');
      dispatch(RefreshActions.getRefreshRequest({ token: refreshToken }));
      return refreshToken
    }
    autoLogin()
  }, []);

  useEffect(() => {
    updateDataList('1')
  }, []);

  useEffect(() => {
    if (dataProductModelsListUpdate) {
      updateDataList('1')
    }
  }, [dataProductModelsListUpdate]);

  //Functions
  const updateDataList = (selectedPage) => {
    let payloadList = {
      page: selectedPage,
      name: filters.name,
      code: filters.code,
      machineType: filters.machineType,
      machineTypeCode: filters.machineTypeCode
    }
    dispatch(ProductModelsActions.getProductModelsListRequest(payloadList))
  }

  //---Filter
  const updateFilter = () => {
    updateDataList(1)
    setOpenModalFilter(false)
  }

  const setFieldFilter = (name, value) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [name]: value
    }))
  }

  const resetFilters = () => {
    setFilters({
      name: '',
      code: '',
      machineType: '',
      machineTypeCode: ''
    });
    let payloadList = {
      page: '1',
      name: '',
      code: '',
      machineType: '',
      machineTypeCode: ''
    }
    dispatch(ProductModelsActions.getProductModelsListRequest(payloadList))
  }

  const showModalFilter = () => {
    setOpenModalFilter(true);
  }
  const hideModalFilter = () => {
    setOpenModalFilter(false);
  }

  //---Drawer Actions Adicionar || Deletar
  const onCloseDrawer = () => {
    setOpenTypeContentDrawer({
      details: {
        status: false,
        title: `Detalhes ${title}`,
        dataShow: {}
      },
      sugestions: {
        status: false,
        title: `Sugestões de ${title}`,
        dataSugestions: {}
      }
    })
  };

  const handleChangeTypeContentDrawer = (name, dataShow = {}) => {
    if (name === 'detail') {
      setOpenTypeContentDrawer({
        details: {
          status: true,
          title: `Detalhes ${title}`,
          dataShow: dataShow
        },
        sugestions: {
          status: false,
          title: `Sugestões de ${title}`,
          dataSugestions: {}
        }
      })
    } else if (name === 'sugestions') {
      setOpenTypeContentDrawer({
        details: {
          status: false,
          title: `Detalhes ${title}`,
          dataShow: {}
        },
        sugestions: {
          status: true,
          title: `Sugestões de ${title}`,
          dataSugestions: dataShow
        }
      })
    }
  }

  const getTitle = () => {
    if (openTypeContentDrawer?.details?.status) {
      return openTypeContentDrawer?.details?.title
    } else if (openTypeContentDrawer?.sugestions?.status) {
      return openTypeContentDrawer?.sugestions?.title
    }
  }

  //---Configurations Columns Table
  const columns = [
    {
      title: 'Id',
      dataIndex: 'recno',
      key: 'recno',
      render: (text, record, i) =>
        <div className='row px-2'>
          {record?.recno}
        </div>
      ,
    },
    {
      title: 'Cód. Modelo',
      dataIndex: 'code',
      key: 'code',
      render: (text, record, i) =>
        <div className='row px-2'>
          {record?.code}
        </div>
      ,
    },
    {
      title: 'Modelo',
      dataIndex: 'name',
      key: 'name',
      render: (text, record, i) =>
        <div className='row px-2'>
          <b>{record?.name}</b>
        </div>
      ,
    },
    {
      title: 'Cód. Grupo de Máquina',
      dataIndex: 'machine_type_code',
      key: 'machine_type_code',
      render: (text, record, i) =>
        <div className='row px-2'>
          {record?.machine_type?.code}
        </div>
      ,
    },
    {
      title: 'Grupo de Máquina',
      dataIndex: 'machine_type',
      key: 'machine_type',
      render: (text, record, i) =>
        <div className='row px-2'>
          {record?.machine_type?.name}
        </div>
      ,
    },
    {
      title: 'Ativo',
      dataIndex: 'deleted_at',
      key: 'deleted_at',
      render: (text, record, i) =>
        <div >
          {(record?.deleted_at === null) ?
            <CheckOutlined style={{ fontSize: 18, color: "#52c41a" }} />
            :
            <CloseOutlined style={{ fontSize: 18, color: "#dc3545" }} />
          }
        </div>
      ,
    },
    {
      title: 'Ações',
      dataIndex: 'actions',
      key: 'actions',
      render: (text, record, index) => (
        < Space size="middle" >
          <Button
            size='small' type="primary" style={{ background: colorWarning }}
            onClick={() => handleChangeTypeContentDrawer('detail', record)}
          >
            Editar
          </Button>

          <Button
            size='small' type="primary" style={{ background: colorInfo }}
            onClick={() => handleChangeTypeContentDrawer('sugestions', record)}
          >
            Sugestões
          </Button>
        </Space >
      ),
    },
  ];

  //Render
  return (
    <>
      <Content>
        <Breadcrumb
          className='breadcrumb px-3 py-2'
          items={[{
            title: 'Máquinas',
          },
          { title: title }]}
        />
        <div
          className='px-4 py-3'
          style={{ background: colorBgContainer }}
        >
          <div className='container'>
            <div className='row justify-content-between'>
              <div className='p-2'>
                <Button
                  size='small'
                  className='m-2'
                  type="primary"
                  style={{ background: colorInfo }}
                  onClick={showModalFilter}
                >
                  Adicionar Filtros
                </Button>
                <Button
                  size='small'
                  className='m-2'
                  onClick={() => {
                    resetFilters()
                  }}
                  style={{ background: colorError }}
                  type='primary'
                >
                  Limpar Filtros
                </Button>
              </div>
              <div className='p-2'>
              </div>
            </div>
          </div>
          <div className='table-content'>
            <Table pagination={false} loading={(loadingProductModelsList) && { indicator: <LoadingOutlined /> }} rowKey="id" columns={columns} dataSource={dataProductModelsList?.data} />
          </div>
          {
            dataProductModelsList?.last_page > 1 &&
            <div className='m-3 text-right'>
              <Pagination
                pageSize={dataProductModelsList?.per_page}
                showSizeChanger={false}
                showTotal={(total, range) => `${total} itens`}
                onChange={(e) => updateDataList(e)}
                current={dataProductModelsList?.current_page}
                defaultPageSize={`${dataProductModelsList?.per_page}`}
                total={dataProductModelsList?.total}
              />
            </div>
          }
        </div>

        {/* Modal Filters */}
        <Modal title="Filtros"
          open={openModalFilter}
          footer={null}
          onCancel={hideModalFilter}
        >
          <div className='p-2' style={{ backgroundColor: '#f0f2f5' }}>
            <Formik
              initialValues={{
                name: filters?.name,
                code: filters?.code,
                machineType: filters?.machineType,
                machineTypeCode: filters?.machineTypeCode,
              }}
              validationSchema={filterListSchema}
              onSubmit={() => (
                updateFilter()
              )
              }
            >
              {({ handleSubmit, values, errors, touched }) => (
                <div>
                  <Row gutter={[16, 16]}>
                    <Col span={12}>
                      <label className='p-2' htmlFor="code">Cód. Modelo</label>
                      <Input
                        className='input-default'
                        value={filters.code}
                        onChange={(e) => setFieldFilter('code', e.target.value)}
                        size="large"
                        placeholder="Cód. Modelo"
                      />
                    </Col>
                    <Col span={12}>
                      <label className='p-2' htmlFor="name">Modelo</label>
                      <Input
                        className='input-default'
                        value={filters.name}
                        onChange={(e) => setFieldFilter('name', e.target.value)}
                        size="large"
                        placeholder="Modelo"
                      />
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={12}>
                      <label className='p-2' htmlFor="machineTypeCode">Código Grupo de Máquinas</label>
                      <Input
                        className='input-default'
                        value={filters.machineTypeCode}
                        onChange={(e) => setFieldFilter('machineTypeCode', e.target.value)}
                        size="large"
                        placeholder="Código Grupo de Máquinas"
                      />
                    </Col>
                    <Col span={12}>
                      <label className='p-2' htmlFor="machineType">Grupo de Máquinas</label>
                      <Input
                        className='input-default'
                        value={filters.machineType}
                        onChange={(e) => setFieldFilter('machineType', e.target.value)}
                        size="large"
                        placeholder="Grupo de Máquinas"
                      />
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={24}>
                      <Button
                        size='small'
                        className='m-2'
                        disabled={(loadingProductModelsList) ? true : false}
                        loading={(loadingProductModelsList) ? true : false}
                        onClick={() => handleSubmit(values)}
                        type="primary"
                      >
                        Filtrar
                      </Button>
                    </Col>
                  </Row>
                </div>
              )}
            </Formik>
          </div>
        </Modal>

        {/* Modal Actions Show */}
        <Drawer
          title={getTitle()}
          className="drawer-productsmodels-show"
          placement={'right'}
          closable={true}
          onClose={onCloseDrawer}
          open={openTypeContentDrawer?.details?.status}
          key={'right'}
          closeIcon={<CloseOutlined />}
          width={'40%'}
        >
          <>
            {
              (openTypeContentDrawer?.details.status) &&
              <>
                <Show dataShow={openTypeContentDrawer?.details?.dataShow}></Show>
              </>
            }
          </>
        </Drawer>

        {/* Modal Actions Sugestions */}
        <Drawer
          title={getTitle()}
          className="drawer-productsmodels-sugestions"
          placement={'right'}
          closable={true}
          onClose={onCloseDrawer}
          open={openTypeContentDrawer?.sugestions?.status}
          key={'sugestions'}
          closeIcon={<CloseOutlined />}
          width={'99%'}
        >
          <>
            {
              (openTypeContentDrawer?.sugestions.status) &&
              <>
                <Sugestions dataSugestions={openTypeContentDrawer?.sugestions?.dataSugestions}></Sugestions>
              </>
            }
          </>
        </Drawer>
        <FooterDefault />
      </Content>
    </>
  );
};

export default Models;